import { Component, h, Method, Prop, Watch } from '@stencil/core';
export class ErrorSummaryComponent {
  constructor() {
    this.message = 'There’s a problem. Fix the $$invalidFieldCount issues below to continue.';
    this.errorLinkText = 'Go to first error';
    this.tmpMessage = '';
    this.tmpErrorLinkText = '';
    /**
     * The count of errors to be displayed in the message
     */
    this.invalidFieldCount = 0;
  }
  updateInvalidFieldCount() {
    this.tmpMessage = this.message;
    this.tmpErrorLinkText = this.errorLinkText;
    if (this.invalidFieldCount === 1) {
      this.tmpMessage = this.tmpMessage.replace('$$invalidFieldCount issues', 'issue');
      this.tmpErrorLinkText = this.errorLinkText.replace('first ', '');
    }
    else {
      this.tmpMessage = this.tmpMessage.replace('$$invalidFieldCount', this.invalidFieldCount.toString());
    }
  }
  componentWillLoad() {
    this.updateInvalidFieldCount();
  }
  /**
   * Sets focus to the Error summary
   */
  async setFocus() {
    setTimeout(() => this.notificationCard.shadowRoot.querySelector('agl-ds-link').shadowRoot.querySelector('a').focus());
  }
  render() {
    return (h("host", null,
      h("div", { class: "notification-card" },
        h("agl-ds-notification", { ref: (el) => (this.notificationCard = el), type: "error", message: this.tmpMessage, linkText: this.tmpErrorLinkText, linkHref: `#${this.firstInvalidInputId}`, linkOpenNewWindow: false })),
      h("agl-ds-spacer", { orientation: "vertical", size: "space04" })));
  }
  static get is() { return "agl-ds-error-summary"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["error-summary.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["error-summary.component.css"]
  }; }
  static get properties() { return {
    "invalidFieldCount": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The count of errors to be displayed in the message"
      },
      "attribute": "invalid-field-count",
      "reflect": false,
      "defaultValue": "0"
    },
    "firstInvalidInputId": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The id of the first input to receive focus on the click of the link"
      },
      "attribute": "first-invalid-input-id",
      "reflect": false
    }
  }; }
  static get methods() { return {
    "setFocus": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "Sets focus to the Error summary",
        "tags": []
      }
    }
  }; }
  static get watchers() { return [{
      "propName": "invalidFieldCount",
      "methodName": "updateInvalidFieldCount"
    }]; }
}
